/** Reports Dashboard permission keys from GET /permission/get/:role_id. */
export const REPORTS_DASHBOARD_PERMISSION_KEYS = {
  CATEGORY_MANAGEMENT: "category_management",
} as const;

export type ReportsDashboardPermissionKey =
  (typeof REPORTS_DASHBOARD_PERMISSION_KEYS)[keyof typeof REPORTS_DASHBOARD_PERMISSION_KEYS];
